module.exports = __webpack_public_path__ + "media/images/world-map-background-c6b88ff20e71ec5c690f20518ce68979.png";